import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=7a861ee7&scoped=true"
var script = {}
import style0 from "./Loader.vue?vue&type=style&index=0&id=7a861ee7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a861ee7",
  null
  
)

export default component.exports